import type { MessageKey } from '@/i18n'

export type TeamKind = 'VILLAGE' | 'SITE'

/** The words for the list a phone downloads: the farmer list (village) or the store list (site). */
export interface ListWords {
  label: MessageKey
  update: MessageKey
  updated: MessageKey
  age: MessageKey
  never: MessageKey
  stale: MessageKey
  expired: MessageKey
  noTeam: MessageKey
}

const VILLAGE: ListWords = {
  label: 'device.rosterLabel',
  update: 'device.downloadRoster',
  updated: 'device.rosterUpdated',
  age: 'device.rosterAge',
  never: 'device.rosterNever',
  stale: 'device.rosterStale',
  expired: 'device.rosterExpired',
  noTeam: 'pin.noTeam',
}

const SITE: ListWords = {
  label: 'device.storeListLabel',
  update: 'device.downloadStoreList',
  updated: 'device.storeListUpdated',
  age: 'device.storeListAge',
  never: 'device.storeListNever',
  stale: 'device.storeListStale',
  expired: 'device.storeListExpired',
  noTeam: 'pin.noTeamSite',
}

/** A phone not registered yet keeps the farmer-list words. */
export function listWords(kind: TeamKind | null | undefined): ListWords {
  return kind === 'SITE' ? SITE : VILLAGE
}
